<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h2 class="m-0 h1 text-uppercase mb-3">Selecciona tus {{ footer.termino_entradas }}</h2>
            </div>
            <div class="col-12 col-lg-8 mb-3 mb-lg-0">
                <transition name="fade" mode="out-in">
                    <div v-if="!loading" key="mapa-butacas" id="mapa-butacas">
                        <div class="col-12 lightgray-content text-center p-3">
                            <LeafletComponent
                                :plazasSeleccionadas="butacasSeleccionadas"
                                :svgRendered="svgRendered"
                                :originalColor="originalColor"
                                @isPanning="(e) => isPanning = e"
                            />
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-12 text-center" style="height: 500px">
                            <LoaderComponent/>
                        </div>
                    </div>
                </transition>
            </div>
            <div class="col-12 col-lg-4">
                <div class="d-flex flex-column justify-content-between" style="height: 100%;">
                    <div class="overflow-auto tusEntradas">
                        <div 
                            v-for="(butaca, index) in butacasSeleccionadas"
                            class="lightgray-content p-2 mb-2"
                            :key="index"
                        >
                            <div class="text-bold mb-2 d-flex justify-content-between">
                                <div class="oswald d-flex">
                                    {{ (num = index + 1) }}. {{ getButacaName(butaca) }}
                                </div>
                                <span role="button" class="oswald" @click="clickButaca(butaca.id)">
                                    <i class="fas fa-times mr-2"></i>
                                </span>
                            </div>
                            <div class="form-group mb-1">
                                <ValidationProvider
                                    :name="'precio' + index"
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <select
                                        :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                        v-model="butaca.precioSeleccionado"
                                        name="precio"
                                        data-cy="selectEntradas"
                                        @change="butacasConPrecios"
                                        :disabled="bloquearPaso"
                                    >
                                        <option :value="undefined" disabled hidden>
                                            {{ $t("partido.tipo_entrada") }}
                                        </option>
                                        <option
                                            v-for="(precio, index) in butaca.precios"
                                            :key="index"
                                            :value="precio"
                                        >
                                            {{ precio.descripcion }} / {{ precio.precio | formatear_precio }}
                                        </option>
                                    </select>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                    <b-button 
                        v-if="butacasSeleccionadas.length > 0 && confValida && !ocultarBoton" 
                        class="btn btn-block mb-0"
                        :disabled="continuarConCompra || !preciosEnButacas || bloquearPaso"
                        @click="continuarCompra"
                    >
                        {{ $t('partido.continuar') }}
                    </b-button>
                    <div 
                        v-else-if="butacasSeleccionadas.length > 0 && !confValida"
                        class="text-white bg-danger p-2 font-weight-bold rounded w-100 text-center"
                    >
                        ¡No puedes dejar huecos entre butacas!
                    </div>
                    <LoaderComponent v-if="ocultarBoton"></LoaderComponent>
                </div>
            </div>
        </div>
        <ModalRegionSinNumerar
            v-if="showModalRegionSinNumerar"
            :precios="preciosSeleccionados"
            :regionSeleccionada="regionSeleccionada"
            @setAsientos="(asientos) => $emit('setAsientos', asientos)"
            @close="closeModal"
        />
    </div>
</template>

<script>
import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
import comprobarButacasLeaflet from '@/mixins/comprobarButacasLeaflet.js';
import { Popover } from 'bootstrap';
import ModalRegionSinNumerar from './ModalRegionSinNumerar.vue';

export default {
    props: {
        recinto_id: {
            type: Number,
            required: true
        },
        continuarConCompra: {
            type: Boolean,
            required: true
        },
        configuracion: {
            type: Object,
            required: true
        },
        resetButacas: {
            type: Number,
            required: true
        },
        bloquearPaso: {
            type: Boolean,
            required: false
        },
        ocultarBoton: {
            type: Boolean,
            required: false
        },
    },
    mixins: [comprobarButacasLeaflet],
    emits: ['continuarCompra', 'regionSeleccionada', 'setAsientos'],
    data() {
        return {
            loading: false,
            svgRendered: null,
            butacas: null,
            sectores: null,
            originalColor: '#0CBA31',
            noDisponibleColor: 'gray',
            ocupadaColor: 'red',
            seleccionadaColor: '#8CA9D9',
            isPanning: false,
            butacasSeleccionadas: [],
            preciosEnButacas: false,
            regiones: null,
            preciosSeleccionados: null,
            showModalRegionSinNumerar: false,
            regionSeleccionada: null
        }
    },
    created() {
        this.getButacas();
        this.getRegiones();
    },
    watch: {
        butacasSeleccionadas() {
            for (let i in this.butacasSeleccionadas) {
                if (!this.butacasSeleccionadas[i].precioSeleccionado) {
                    this.butacasSeleccionadas[i].precioSeleccionado =
                        this.butacasSeleccionadas[i].precios.length === 1 ? this.butacasSeleccionadas[i].precios[0] : null;
                }
            }
            this.preciosEnButacas = this.butacasSeleccionadas.every(butaca => butaca.precioSeleccionado);
        },
        resetButacas() {
            this.$emit('resetContinuarConCompra');
            this.butacasSeleccionadas = [];
            this.getButacas();
            this.getRegiones();
        }
    },
    computed: {
        footer() {
            return this.$store.getters.getFooter;
        },
        load_panzoom() {
            let load_panzoom = true

            let userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (/windows phone/i.test(userAgent) || /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                load_panzoom = false;
            }

            return load_panzoom;
        },
    },
    methods: {
        getButacas() {
            this.loading = true;

            const params = {
                filters: {},
                event_id: this.$route.params.event_id,
                sesion_id: this.$route.params.sesion_id
            }

            this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.butacas'), params).then(res => {
                this.butacas = res.data.butacas;
                this.sectores = res.data.sectores;
                this.$emit('setButacas', this.butacas);
                this.getSvg();
                this.setPlazasConf(this.butacas);
            }).catch(() => {
                console.error('Error al recuperar las butacas del recinto');
            })
        },
        getRegiones() {
            this.loading = true;

            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro
                },
                evento_id: this.$route.params.event_id,
                sesion_id: this.$route.params.sesion_id
            }

            this.$store.dispatch(this.config.getVuexAlias('front.evento.regiones.sin-asientos'), params).then(res => {
                this.regiones = res.data.data;
            }).catch(e => {
                console.log(e);
            })
        },
        getSvg() {
            const params = {
                filters: {},
                recinto_id: this.recinto_id
            }

            this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params).then(res => {
                this.renderLeafletSvg(res.data.svg);
                this.loading = false;
                setTimeout(() => {
                    this.$scrollTo('#mapa-butacas', 300);
                }, 300);
            }).catch(e => {
                console.log(e);
                console.error('Error al obtener el svg general.');
            });
        },
        renderLeafletSvg(svg) {
            const butacasFiltered = this.butacas.filter(butaca => butaca.svg_id);
            const regionesFiltered = this.regiones.filter(region => region.svg_id);

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = svg;

            const svgElement = tempDiv.firstElementChild;
            const butacas = svgElement.querySelectorAll('[id^="butaca"]');
            const regiones = svgElement.querySelectorAll('[id^="region"]');

            butacas.forEach(circle => {
                circle.setAttribute('seleccionado', 'false');
                const svg_id = this.getButacaId(circle);
                const butaca = butacasFiltered.find(butaca => butaca.svg_id == svg_id);

                if (butaca) {
                    const title = this.getButacaName(butaca);

                    if (butaca.disponible && butaca.precios.length > 0) {
                        const content = `Desde: ${this.getPrecioButaca(butaca)} €`
                        this.drawPopover(circle, content, title);

                        circle.style.cursor = 'pointer';
                        circle.style.transition = 'fill 0.2s'
                        circle.setAttribute('fill', this.originalColor);

                        circle.addEventListener('click', () => {
                            let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                            setTimeout(() => {
                                if (!this.isPanning && !this.continuarConCompra) {
                                    if (!isSeleccionado) {
                                        circle.setAttribute('fill', this.seleccionadaColor);
                                        circle.setAttribute('seleccionado', 'true');
                                    } else {
                                        circle.setAttribute('fill', this.originalColor);
                                        circle.setAttribute('seleccionado', 'false');
                                    }
                                    this.clickButaca(butaca.id);
                                }
                            }, 150);
                        });
                    } else if (!butaca.disponible && butaca.precios.length > 0) {
                        this.drawPopover(circle, 'Ocupada', title);
                        circle.setAttribute('ocupada', 'true');
                        circle.setAttribute('fill', this.ocupadaColor)
                        circle.style.fill = 'red';
                    } else {
                        this.drawPopover(circle, 'No disponible', title);
                        circle.setAttribute('no-disponible', 'true');
                        circle.setAttribute('fill', this.noDisponibleColor)
                    }
                }
            });

            regiones.forEach(element => {
                const svg_id = this.getButacaId(element);
                const region = regionesFiltered.find(region => region.svg_id == svg_id);

                if (region) {
                    if (region.libres > 0 && region.precios.length > 0) {
                        const content = this.getRegionPrecio(region);
                        this.drawPopover(element, content, region.nombre);
    
                        element.addEventListener('click', () => {
                            if (!this.continuarConCompra) {
                                const popover = document.querySelector('.popover');
                                if (popover) {
                                    popover.remove();
                                }
                                this.regionSeleccionada = region;
                                this.butacas.forEach(butaca => {
                                    return butaca.seleccionada = false;
                                });
                                this.butacasSeleccionadas = [];
                                this.showModalEntradas(region.precios);                                
                            }
                        });
                    } else if (region.libres <= 0 && region.precios.length > 0) {
                        element.style.fill = 'red';
                        element.style.cursor = 'disabled';
                        this.drawPopover(element, 'Entradas agotadas', region.nombre);
                    } else {
                        element.style.fill = 'gray';
                        element.style.cursor = 'disabled';
                        this.drawPopover(element, 'No disponible', region.nombre);
                    }
                }
            });

            this.svgRendered = tempDiv.firstElementChild;
        },
        drawPopover(circle, content, title = null) {
            if (this.load_panzoom) {
                const popoverOptions = {
                    html: true,
                    title: title,
                    content: content,
                    trigger: 'hover'
                }

                return new Popover(circle, popoverOptions);
            }
        },
        getButacaId(circle) {
            const id = circle.id;
            const idParts = id.split("-");

            return idParts[1];
        },
        getButacaName(butaca) {
            const nButaca = butaca.butaca;
            const nFila = butaca.fila;
            const sector = this.sectores.find(sector => sector.id == butaca.sector);

            let name = '';
            if(sector) {
                name += `Sector: ${sector.name} - `;
            }

            return name +=  `Fila: ${nFila} - Butaca: ${nButaca}`;
        },
        getPrecioButaca({ precios }) {
            if (precios.length > 0) {
                let precioMasBajo = precios.reduce((menorPrecio, precio) => {
                    return Math.min(menorPrecio, precio.precio);
                }, Number.POSITIVE_INFINITY)

                return Math.ceil(precioMasBajo * 100) / 100;
            }

            return 0;
        },
        clickButaca(butacaId) {
            if (!this.continuarConCompra && !this.bloquearPaso) {
                this.butacas.find(butaca => {
                    if (butaca.id === butacaId && butaca.disponible && butaca.precios.length > 0) {
                        butaca.seleccionada = butaca?.seleccionada && butaca.seleccionada ? false : true;
                        if (butaca.seleccionada) {
                            this.butacasSeleccionadas.push(butaca);
                            this.butacasSeleccionadas.sort((a, b) => a.butaca - b.butaca);

                        } else {
                            const index = this.butacasSeleccionadas.findIndex(butaca => butaca.id === butacaId);

                            if (index !== -1) {
                                this.butacasSeleccionadas.splice(index, 1);
                            }
                        }
                    }
                });
            }
        },
        butacasConPrecios(e) {
            this.preciosEnButacas = this.butacasSeleccionadas.every(butaca => butaca.precioSeleccionado);
        },
        continuarCompra() {
            this.$emit('continuarCompra', this.butacasSeleccionadas);
        },
        getRegionPrecio(region) {
            const lowestPrice = region.precios.reduce((lowest, current) => {
                const currentPrice = parseFloat(current.precio);
                if (!lowest || currentPrice < lowest) {
                    return currentPrice;
                }

                return lowest;
            }, null);

            return `Desde: ${lowestPrice}€`;
        },
        showModalEntradas(precios) {
            this.preciosSeleccionados = precios;
            this.showModalRegionSinNumerar = true;

            this.$nextTick(() => {
                this.$modal.show('modal-region-sin-numerar');
            })
        },
        closeModal() {
            this.showModalRegionSinNumerar = false;
        }
    },
    components: { LeafletComponent, ModalRegionSinNumerar }
}
</script>

<style scoped>
@media only screen and (min-width: 768px) {
    .tusEntradas {
        height: 486px;
    }
}
</style>